import { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useQuery } from '@percent/utility'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { ErrorView, Loader } from '@percent/admin-dashboard/common/components'
import { useRequiredParams } from '@percent/admin-dashboard/common/hooks'
import { useBreadcrumbsData } from '@percent/admin-dashboard/app/Layout/breadcrumbsContext/useBreadcrumbsData/useBreadcrumbsData'
import { GroupDetail } from './GroupDetail'

export function GroupDetailContainer() {
  const { groupId } = useRequiredParams<{ groupId: string }>()
  const location = useLocation()
  const { setPath } = useBreadcrumbsData()
  const { groupService } = useServices()

  const { data, isLoading, errorMessage } = useQuery([`/groups/${groupId}`], groupService.getGroupById, { id: groupId })

  const groupName = data?.name

  useEffect(() => {
    setPath(groupName)

    return () => setPath(undefined)
  }, [groupName, setPath])

  // Redirect to members tab if on base route
  if (location.pathname === `/accounts/groups/${groupId}`) {
    return <Navigate to={`/accounts/groups/${groupId}/members`} replace />
  }

  if (isLoading) {
    return <Loader />
  }

  if (errorMessage || !data) {
    return <ErrorView errorMessage={errorMessage || 'Group not found'} />
  }

  // eslint-disable-next-line no-underscore-dangle
  const permissions = data._permissions

  return <GroupDetail group={data} permissions={permissions} />
}
